import axios from 'axios';
import axiosRetry from 'axios-retry';

const API_URL = 'https://api.chippedsocial.com';

const client = axios.create({ baseURL: API_URL });

// Configure axios-retry: retry on transient network/5xx
axiosRetry(client, {
  retries: 3,
  retryDelay: (retryCount) => {
    return axiosRetry.exponentialDelay(retryCount);
  },
  retryCondition: (error) => {
    return axiosRetry.isNetworkError(error) || axiosRetry.isRetryableError(error);
  },
});

// Fetch basic profile data
export const getUserProfile = async (user_id) => {
  const response = await client.get(`/users/${user_id}`);
  return response.data;
};

// Fetch social links for user (new format)
export const getUserSocialLinks = async (user_id) => {
  const response = await client.get(`/users/${user_id}/social-links`);
  return response.data;
};

// (Optional, still part of your app)
export const getAllConnectionsForUser = async (user_id) => {
  const response = await client.get(`/users/${user_id}/connections`);
  return response.data;
};

export const getActivityForUser = async (user_id) => {
  const response = await client.get(`/users/${user_id}/activity`);
  return response.data;
};

// Fetch all unlocked badges for a user
export const fetchAllBadgesForUser = async (user_id) => {
  const response = await client.post(`/users/badges/${user_id}`, { user_id });
  return response.data;
};

// Unified tap claim endpoint
export const claimTap = async (payload) => {
  try {
    const response = await client.post('/nfc/validate-and-award', payload);
    return response.data;
  } catch (error) {
    console.error('Error claiming tap:', error);

    return {
      success: false,
      message: error.response?.data?.message || 'Error claiming tap',
    };
  }
};
